import React, { useState } from 'react';
import { useHistory } from 'react-router';

import { Panel } from '../common/panel/Panel.component';
import { Button, Colors } from '../legacy/button/Button.component';
import { Input, InputType } from '../legacy/input/Input.component';
import styles from './ResetPassword.module.css';

interface Props {
  onPasswordResetInitPress: (email: string) => void;
}

export const ResetPasswordInitComponent: React.FC<Props> = ({
  onPasswordResetInitPress,
}) => {
  const history = useHistory();

  const [email, setEmail] = useState('');

  const goToSignUp = () => {
    history.push('/register');
  };

  return (
    <div className={styles.resetContainer}>
      <Panel className={styles.resetForm} title="Reset Password">
        <p className={styles.resetLabel}>
          Confirm your email to reset your password.
        </p>
        <div className={styles.resetInput}>
          <div>
            <Input
              type={InputType.TEXT}
              label="Email Address"
              value={email}
              onChange={setEmail}
            />
          </div>
          <Button
            color={Colors.COLOR_SCHEME_2}
            className={styles.resetAction}
            disabled={!email}
            onClick={() => {
              onPasswordResetInitPress(email);
            }}
          >
            Send Link
          </Button>
        </div>
      </Panel>
      <p className={styles.signUpLabel}>Don't have an Account?</p>
      <Button
        color={Colors.COLOR_SCHEME_3}
        className={styles.signUpButton}
        onClick={goToSignUp}
      >
        Sign Up
      </Button>
    </div>
  );
};
